import React from 'react'

interface Props {
  data: {
    timeUsed?: string
    timeSaved?: string
    confirmed?: string
    confirmedDesc?: string
  }
}

export const StatCard: React.FC<Props> = ({ data }) => (
  <div className="aiClerk-att-stat">
    {data.timeUsed && (
      <div className="aiClerk-att-stat__col">
        <div className="aiClerk-att-stat__icon">⏱</div>
        <div>
          <div className="aiClerk-att-stat__main">{data.timeUsed}</div>
          {data.timeSaved && (
            <div className="aiClerk-att-stat__sub">{data.timeSaved}</div>
          )}
        </div>
      </div>
    )}
    {data.confirmed && (
      <div className="aiClerk-att-stat__col aiClerk-att-stat__col--ok">
        <div className="aiClerk-att-stat__badge">✓ {data.confirmed}</div>
        {data.confirmedDesc && (
          <div className="aiClerk-att-stat__sub">{data.confirmedDesc}</div>
        )}
      </div>
    )}
  </div>
)
